import { CardType } from '@/common/constants/cards.constant'
import FleetCardDetails from '../components/cards/FleetCardDetails'
import PersonalCardDetails from '../components/cards/PersonalCardDetails'

export const cardDetailsComponents = {
  [CardType.Fleet]: FleetCardDetails,
  [CardType.Personal]: PersonalCardDetails,
}
